import Qa, { IQa, IQaApiModel } from './Qa.model';

export interface IProductQa {
  id: number;
  qaId: string;
  qa: IQa;
}

export interface IProductQaApiModel {
  id: number;
  qaId: string;
  qa: IQaApiModel;
}

export default class ProductQa implements IProductQa {
  public readonly id: number;

  public readonly qaId: string;

  public readonly qa: IQa;

  constructor(id: number, qaId: string, qa: IQa) {
    this.id = id;
    this.qaId = qaId;
    this.qa = qa;
  }

  static fromApiModel(apiModel: IProductQaApiModel) {
    const { id, qaId } = apiModel;

    const qa = Qa.fromApiModel(apiModel.qa);
    return new ProductQa(id, qaId, qa);
  }

  static arrayFromApiModel(arrayApiModel: IProductQaApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, qaId } = apiModel;

      const qa = Qa.fromApiModel(apiModel.qa);

      return new ProductQa(id, qaId, qa);
    });

    return array;
  }
}
